export default __webpack_public_path__ + "static/media/sofa_bed.c6433cca.svg";